import useDropdownFilter from "./hooks/useDropdownFilter";
import DropdownSelector from "../../components/DropdownSelector";

const DropdownFilter = ({ parameter, onFilterChange }) => {
  const { dropdown } = useDropdownFilter({ parameter, onFilterChange });
  return (
    <div
      style={{
        width:
          parameter?.id === "WIDTH" ? "var(--width-24)" : "var(--width-64)",
      }}
    >
      <DropdownSelector {...dropdown} />
    </div>
  );
};

export default DropdownFilter;
